module.exports = "<h1 class=\"alpha\">\n    {{ titleTxt }}\n</h1>\n"


//////////////////
// WEBPACK FOOTER
// ../~/noop-loader!./components/xo-title/dist/template.html
// module id = ../node_modules/noop-loader/index.js!./components/xo-title/dist/template.html
// module chunks = 1